<template>
  <van-dialog
    class="create-notice-dialog"
    :title="options.title"
    :width="options.width"
    :visible.sync="isOpened"
    :close-on-click-modal="false"
    :close-on-press-escape="false">
    <div v-html="options.message"></div>
    <div class="ckb">
      <el-checkbox v-model="createNoticeSilent">不再提醒</el-checkbox>
    </div>
    <div slot="footer" class="dialog-footer" v-if="!options.hideFooter">
      <el-button type="primary" @click="isOpened = false">{{confirmText}}</el-button>
    </div>
  </van-dialog>
</template>

<script>
import { Dialog, Checkbox, Button } from 'element-ui';

export default {
  name: 'NoticeDialog',
  components: {
    VanDialog: Dialog,
    ElCheckbox: Checkbox,
    ElButton: Button,
  },
  data() {
    return {
      isOpened: false,
      createNoticeSilent: false,
      options: {
        width: '30%',
        title: '',
        message: '',
        hideFooter: false,
        confirmText: '',
      },
    };
  },
  watch: {
    isOpened(value) {
      /* eslint-disable */
      if (value) {
        document.body.appendChild(this.$el);
      } else {
        setTimeout(() => {
          document.body.removeChild(this.$el);
        }, 1000);
      }
    },
  },
  methods: {
    open({ title, width, message }) {
      if (title) {
        this.options.title = title;
      }
      if (message) {
        this.options.message = message;
      }
      if (width) {
        this.options.width = width;
      }
      this.isOpened = true;
    },
  },
};
</script>

<style lang="scss">
.create-notice-dialog {
  line-height: 1.5;
  .el-dialog__body {
    padding: 30px 30px;
  }
  .ckb {
    margin-top: 20px;
    margin-bottom: -70px;
  }
  .dialog-footer {
    margin-top: -10px;
  }
}
</style>
